import script from "./ChessSquare.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChessSquare.vue?vue&type=script&lang=ts&setup=true"

import "./ChessSquare.vue?vue&type=style&index=0&id=6dbf989c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\git\\git\\chess-com-frontend-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dbf989c"]])

export default __exports__